import React from "react";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import { Toaster } from "@shadcn-in-nx/ui/sonner";
import { useAuth } from "../context/AuthContext";
import { ManageCompanyProvider, useManageCompany } from "../Admin/ManageCompany/ManageCompanyContext";

function AdminLayoutInner({ children, headerHidden, user }) {
    const { t } = useTranslation();
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const { open: openManageCompany } = useManageCompany();

    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

    const MENU = React.useMemo(
        () => [
            { label: "Main menu", section: true },
            { label: "Users", route: "/admin", icon: "Users" },
            { label: "Support Tickets", route: "/admin/support", icon: "LifeBuoy" },
            { label: "Chats", route: "/admin/chats", icon: "Chat" },
            { label: "Workflows", route: "/admin/all-workflows", icon: "Workflow" },
            { label: "Credits", route: "/admin/credits", icon: "CreditCard" },
            {
                label: t("admin.manageCompany.menu", "Manage Company"),
                route: "#",
                icon: "Building",
                onClick: () => openManageCompany(null),
            },
            { label: "Support Hours", route: "/admin/support-hours", icon: "Clock" },
            { label: "Blueprint Requests", route: "/admin/blueprint-requests", icon: "Sparkles" },
            { label: "User Insights", route: "/admin/user-insights", icon: "BarChart3" },
            { label: "FB Pixel Audit", route: "/admin/facebook-audit", icon: "Activity" },
            { label: "Intelligence", route: "/admin/intelligence", icon: "Brain" },
            { label: "Company Settings", route: "/admin/automation-usage", icon: "Gauge" },
            { label: "Automation Agent", route: "/admin/automation-playground", icon: "Zap" },
            { label: "Data Migration", route: "/admin/data-migration", icon: "Database" },
            { label: "PMF Survey", route: "/admin/pmf-survey", icon: "ClipboardCheck" },
            { label: "Harness Reports", route: "/admin/harness-reports", icon: "AlertTriangle" },
        ],
        [t, openManageCompany]
    );

    return (
        <>
            <div className="h-screen flex flex-col">
                {!headerHidden && (
                    <Header
                        toggleSidebar={toggleSidebar}
                        sidebarOpen={sidebarOpen}
                    />
                )}
                <div className="flex flex-1 relative overflow-hidden min-h-0">
                    <Sidebar
                        isOpen={sidebarOpen}
                        setIsOpen={setSidebarOpen}
                        menu={MENU}
                        user={user}
                    />
                    <main
                        className={`flex-1 overflow-y-auto transition-all duration-300 ${
                            sidebarOpen ? "lg:ml-64" : "lg:ml-[68px]"
                        }`}
                    >
                        {children}
                    </main>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
}

const AdminLayout = ({ children, headerHidden = false }) => {
    const { user, isSuperAdmin, isSupport, isLoadingUser } = useAuth();

    if (isLoadingUser) {
        return null;
    }

    if (!isSuperAdmin && !isSupport) {
        return <Navigate to="/" />;
    }

    return (
        <ManageCompanyProvider>
            <AdminLayoutInner headerHidden={headerHidden} user={user}>
                {children}
            </AdminLayoutInner>
        </ManageCompanyProvider>
    );
};

export default AdminLayout;
